import wixData from 'wix-data';
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
import { getLoggedInUserId } from 'public/users.js'
import { checkCurrentItems } from 'backend/checkItems';
import { biLoggerFactory } from 'wix-private';
const biLogger = biLoggerFactory('lp', 19, { msid: '718cadd3-7bad-467a-be46-6784c8ec3e57' });

let language, userId, countryCode, referral, clientId;

export async function implementBi(button) {
	//Add your code for this event here: 
	const biEventObject = {
		evid: 703,
		'button_name': button,
		'url': wixLocation.url
	};
	await biLogger.log(biEventObject);
}

$w.onReady(async function () {
	pageEvents();
	language = await wixWindow.browserLocale.slice(0, 2)
	countryCode = await wixWindow.browserLocale.slice(3)
	const success = await getLoggedInUserId();
	referral = await wixWindow.referrer;
	userId = success.slice(success.indexOf('"guid":"') + 8, success.indexOf('"guid":"') + 44);

	wixData.query("faildLeads").find()
		.then(async (res) => {
			if (res.items.length > 0) {
				await checkCurrentItems();
			}
		});
});

async function pageEvents() {
	$w("#requestACall").onClick(async () => {
		await implementBi("requestACall - Fold 1");
		$w('#text87').scrollTo()

	})
	$w("#button114").onClick(async () => {
		await implementBi("requestACall - Fold 2");
		$w('#text87').scrollTo()
	})
	$w("#button115").onClick(async () => {
		await implementBi("requestACall - Fold 3");
		$w('#text87').scrollTo()
	})
	$w("#button116").onClick(async () => {
		await implementBi("requestACall - Fold 4");
		$w('#text87').scrollTo()
	})
	$w("#button117").onClick(async () => {
		await implementBi("requestACall - Fold 5");
		$w('#text87').scrollTo()
	})

}

export async function formSubmit_click(event) {
	if ($w("#firstNameInput").valid && $w("#lastNameInput").valid && $w("#emailInput").valid && $w("#formCheckbox").valid) {
		$w('#formSubmit').disable();
		const newLeadToInsert = {
			'email': $w("#emailInput").value,
			'firstName': $w("#firstNameInput").value,
			'lastName': $w("#lastNameInput").value,
			'phone': $w("#phoneInput").value.toString(),
			'extraMessage': $w("#messageInput").value,
			'company': $w("#company").value,
			'jobTitle': $w("#jobTitle").value,
			'userId': userId,
			'inputReferral': referral,
			'clientId': clientId,
			'language': language,
			'countryCode': countryCode,
			'source': 'Editorx Enterprise LP'
		}

		let lead = await wixData.insert("Enterprisesubmission", newLeadToInsert);
		const biObj = {
			evid: 731,
			form_detals: JSON.stringify(lead),
			form_is_valid: true,
			url: wixLocation.url,
			leadId: lead._id,
			topic: 'Enterprise'
		}
		await biLogger.log(biObj);
		wixWindow.openLightbox("Enterprise Lightbox");
	} else {
		const inputs = ["#firstNameInput", "#lastNameInput", "#emailInput", "#formCheckbox"];
		inputs.forEach((input) => {
			if (!$w(input).valid) {
				$w(input).updateValidityIndication();
			}
		})
	}
}

function createCustomValidations() {
	$w("#phoneInput").onCustomValidation((value, reject) => {
		if (value[0] === "+") {
			if (isNaN(value.substring(1))) {
				reject("Please only enter a number")
			}
		} else if (isNaN(value) || value[0] === "-" || value.length < 6) {
			reject("Please enter a valid phone number")
		}
	})
}